export default {
  modal: {
    index: {
      title: 'Choose a Card',
      saveButton: 'Use Card',
      cancel: 'Cancel',
    },
    addNew: {
      title: 'Add New Card',
      saveButton: 'Save and Use Card',
      saveDefault: 'Save as default card',
      billingSame: 'Billing address is the same as shipping address',
      billingAddressTitle: 'Billing Address',
      backButton: 'Go back',
      troubleshooting: 'Troubleshooting tips',
    },
  },
};
